import { ShowSpinner, HideSpinner, SpinWhile } from "./spinner";
import { Alert,Confirm } from "./altert-confirm";
import { ShowDialogModal } from "./modal";
import { ShowToast, HideToast, ToastDanger, ToastInfo, ToastSuccess, ToastWarning } from "./toast";
import { ToggleDropdown, ToggleNextDropdown } from "./dropdown";
import "./admin-panel";
import "./icon";

(<any>globalThis).Alvar={
    ShowSpinner,
    HideSpinner,
    SpinWhile,
    Alert,
    Confirm,
    ShowDialogModal,
    ShowToast,HideToast,ToastSuccess,ToastWarning,ToastDanger,ToastInfo,
    ToggleDropdown,
    ToggleNextDropdown
};
